<template>
  <div
    v-if="visible"
    id="confirm-modal"
    class="vc-overlay rep-app-confirm-dialog"
  >
    <div class="vc-container">
      <span class="vc-text-grid">
        <h4 class="vc-title">{{ title }}</h4>
        <p class="vc-text">{{ message }}</p>
      </span>
      <div class="vc-btn-grid">
        <button class="vc-btn left" @click="$emit('cancel')">No</button>
        <button class="vc-btn right" @click="handleConfirm">Yes</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "ConfirmModal",
  props: {
    visible: Boolean,
    title: String,
    message: String,
    userId: Number,
  },
  methods: {
    handleConfirm() {
      this.$emit("cancel");
      if (this.title === "Delete Admin") {
        this.deleteUser(this.userId);
      } else if (this.title === "Suspend Admin") {
        this.handleSuspend(this.userId);
      } else if (this.title === "Activate Admin") {
        this.activateUser(this.userId);
      }
    },
    deleteUser(userId) {
      const url = `delete-member-user/${userId}`;
      let loader = this.$loading.show();

      axios
        .delete(url)
        .then((res) => {
          this.$notify(res.data.message, "success");
        })
        .catch((err) => {
          const errorMsg =
            err?.response?.data?.message || "Something went wrong";
          this.$notify(errorMsg, "error");
        })
        .finally(() => {
          loader.hide();
          this.$emit("success");

        });
    },

    handleSuspend(userId) {
      const url = `activate-deactivate-member-user?member_user_id=${userId}`;
      let loader = this.$loading.show();

      axios
        .post(url) // no payload needed in body
        .then((res) => {
          this.$notify(res.data.message, "success");
        })
        .catch((err) => {
          const errorMsg =
            err?.response?.data?.message || "Something went wrong";
          this.$notify(errorMsg, "error");
        })
        .finally(() => {
          loader.hide();
          
          this.$emit("success");

        });
    },

    activateUser(userId) {
      const url = `activate-deactivate-member-user?member_user_id=${userId}&activate=true`;
      let loader = this.$loading.show();

      axios
        .post(url) // no payload needed in body
        .then((res) => {
          this.$notify(res.data.message, "success");
        })
        .catch((err) => {
          const errorMsg =
            err?.response?.data?.message || "Something went wrong";
          this.$notify(errorMsg, "error");
        })
        .finally(() => {
          loader.hide();
         this.$emit("success");

        });
    },
  },
};
</script>
<style>
.vc-overlay.rep-app-confirm-dialog {
  z-index: 500 !important; /* or whatever lower value you need */
}

</style>